export const CHANGE_LANG = 'CHANGE_LANG'
export const CHANGE_TITLE = 'CHANGE_TITLE'
